export type TruckCheckMode = "daily" | "monthly";

export interface TruckCheckViewState {
  mode: TruckCheckMode;
  apparatusId: string;
  checkId: string;
  bagId: string;
  historyView: boolean;
}

export interface TruckCheckViewPatch {
  mode?: TruckCheckMode;
  apparatusId?: string | null;
  checkId?: string | null;
  bagId?: string | null;
  historyView?: boolean;
}

export function readTruckCheckViewState(searchParams: URLSearchParams): TruckCheckViewState {
  return {
    mode: searchParams.get("mode") === "daily" ? "daily" : "monthly",
    apparatusId: searchParams.get("apparatus")?.trim() ?? "",
    checkId: searchParams.get("check")?.trim() ?? "",
    bagId: searchParams.get("bag")?.trim() ?? "",
    historyView: searchParams.get("view") === "history"
  };
}

export function updateTruckCheckViewSearchParams(
  current: URLSearchParams,
  patch: TruckCheckViewPatch
): URLSearchParams {
  const next = new URLSearchParams(current);

  const setOrDelete = (key: string, value: string | null | undefined) => {
    if (value == null || value === "") {
      next.delete(key);
    } else {
      next.set(key, value);
    }
  };

  if (patch.mode !== undefined) setOrDelete("mode", patch.mode);
  if (patch.apparatusId !== undefined) setOrDelete("apparatus", patch.apparatusId);
  if (patch.checkId !== undefined) setOrDelete("check", patch.checkId);
  if (patch.bagId !== undefined) setOrDelete("bag", patch.bagId);
  if (patch.historyView !== undefined) setOrDelete("view", patch.historyView ? "history" : null);

  return next;
}

export function selectTruckCheckBagId<T extends { bagId: string; complete: boolean }>(
  bags: T[],
  preferredBagId: string
): string {
  if (preferredBagId && bags.some((bag) => bag.bagId === preferredBagId)) {
    return preferredBagId;
  }
  return bags.find((bag) => !bag.complete)?.bagId ?? bags[0]?.bagId ?? "";
}
